<template>
  <div class="register-container">
    <img
    class="logo-cover"
    style="width: 150px"
    :src="require('../../assets/img/logo.png')"
    />
    <div class="slider slider1" v-if="slider == 'slider1'">
      <div class="slider-base">
        <div class="slider-text">
          <h3>Have amazing access to Electricity</h3>
          <p>
            Arnergy is for anyone who longs for easier and convienient ways to
            get energy supply
          </p>
        </div>

        <ul class="slider-state">
          <li class="active"></li> <li></li> <li></li>
        </ul>
      </div>
    </div>
    <div class="slider slider2" v-if="slider == 'slider2'">
      <div class="slider-base">
        <div class="slider-text">
          <h3>Have amazing access to Electricity</h3>
          <p>
            Arnergy is for anyone who longs for easier and convienient ways to
            get energy supply
          </p>
        </div>

        <ul class="slider-state">
          <li></li> <li class="active"></li> <li></li>
        </ul>
      </div>
    </div>
    <div class="slider slider3" v-if="slider == 'slider3'">
      <div class="slider-base">
        <div class="slider-text">
          <h3>Have amazing access to Electricity</h3>
          <p>
            Arnergy is for anyone who longs for easier and convienient ways to
            get energy supply
          </p>
        </div>

        <ul class="slider-state">
          <li></li> <li></li> <li class="active"></li>
        </ul>
      </div>
    </div>


    <div class="form-side">
      <p class="alt-text">
        Remember now? 
        <router-link class="signup-link" to="/auth/login">Login</router-link>
      </p>
      <div class="register-form">      
        <div class="form-box" >
          <div class="main-form-box">
            <form action="#" class="form-container">
              <div v-if="regSuccess" class="reset-form">
                <h3 class="big-text success">Success!</h3>
                <p class="small-text success">A password recovery email has been sent to your inbox</p>
                <button 
                  class="form-button"
                  type="button"
                  @click="goToLogin"
                  >
                  Login
                </button>
              </div>

              <div v-else class="reset-form">
                <h3 class="big-text">Forgot password</h3>
                <p class="small-text">Kindly enter your email below!</p>

                <div class="input-box">
                  <input
                    type="email"
                    class="input"
                    placeholder="Email Address"
                    v-model="regParams.email"
                    required
                  />
                </div>
                <button v-if="loader" class="form-button">
                  <div class="submit-gif">
                    <div
                      class="spinner-border"
                      style="width: 2rem; height: 2rem"
                      role="status"
                    >
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                </button>
                <button v-else @click="submitRequest" class="form-button">Reset Password</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import router from "../../router";

export default {
  name: "forgot-password",
  data() {
    return {
      bgColor: '../../assets/img/bg-image.jpg',
      regSuccess: false,
      regParams: {
        email: null,
        base_url: `${window.location.origin}/auth/new-password`
      },
      slider: 'slider1',
      sliderCount: 1,
      errors: {},
      loader: false,
      displayError: false,
      errorMessage: ""
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!",
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!",
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!",
    },
  },
  methods: {
    isEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    },
    validateReg() {
      var errors = [];
      for (let [field, value] of Object.entries(this.regParams)) {
        switch (field) {
          case "email":
            if (value === "null" || value === "") {
              errors[field] = "Email cannot be empty.";
            } else if (!this.isEmail(value)) {
              errors[field] = "Not a valid email.";
            }
            break;
          default:
            break;
        }
      }
      this.errors = errors;
    },
    submitRequest(e) {
      e.preventDefault();
      var errorLength = Object.keys(this.errors).length;
      var container = this;
      if (errorLength > 0) {
        this.errorMessage = "Fill All FIelds!!!";
        this.displayError = true;
        setTimeout(() => {
          this.displayError = false;
        }, 3000);
        var errorMsg = Object.values(this.errors).join("<br>");
        
        this.showErrorMsg({ message: errorMsg });
      } else {
        var str = JSON.stringify(this.regParams);
        const tempReg = JSON.parse(str);
        const HTTP = this.$httpUtils.instance;
        const url = "/users/reset";
        HTTP.post(url, tempReg)
          .then(response => {
            container.regSuccess = true;
          })
          .catch(error => {
            var errorMsg = error.response.data.error.message;
            console.log(JSON.stringify(error));
            this.showErrorMsg({ message: errorMsg });
          });
      }
    },
    goToLogin(e) {
      e.preventDefault();
      router.push("/auth/login");
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/_reduced_variables.scss";

* {
  transition: 0.3ms ease-in-out;
}

h3,
p,
label,
ul,
li {
  margin: 0;
}

.register-container {
  width: 100%;
  background-color: white;
  display: flex;
}

.slider1 {
  background-image: url('../../assets/img/bg-image.jpg');
  transition: 1ms ease-in-out;
}

.slider2 {
  background-image: url('../../assets/img/slider-image-2.jpg');
  transition: 1ms ease-in-out;
}

.slider3 {
  background-image: url('../../assets/img/slider-image-3.jpg');
  transition: 1ms ease-in-out;
}

.slider {
  width: 60%;
  height: 100vh;
  padding-bottom: 4.5rem;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

img.logo-cover {
  position: absolute;
  top: 3.75rem;
  left: 3.75rem;
  z-index: 1;
}

.slider-base {
  width: 53%;
  text-align: center;
}

.slider-text > h3 {
  font-size: 1.5rem/2.5.5rem;
  margin-bottom: 0.625rem;
}

.slider-text > p {
  font-size: 1rem/1.5rem;
  margin-bottom: 2rem;
}

.slider-state {
  list-style-type: none;
  display: flex;
  width: fit-content;
  margin: 0 auto;
}

.slider-state li {
  width: 0.625rem;
  height: 0.625rem;
  border-radius: 50%;
  margin-right: 0.625rem;
  background-color: #dddddd;
  opacity: 0.5;
}

.slider-state li:last-child {
  margin-right: 0rem;
}

.slider-state li.active {
  width: 1.375rem;
  border-radius: 0.31rem;
  background-color: white;
}

.form-side {
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  flex: 1;
  padding: 6rem 9rem;
  justify-content: center;
}

.register-form {
  color: #727272;
}

.form-box {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.reset-form {
  width: 100%
}

.alt-text {
  font-size: 1.125rem/1.5rem;
  color: #727272;
  margin-left: auto;
  margin-bottom: 3.5rem;
}

.signup-link {
  color: #fe7a11;
}

.main-form-box {
  width: 100%;
  position: relative;
  z-index: 0;
}

.form-container {
  border-radius: 1.875rem 1.875rem 0rem 0rem;
  border: 0.1rem solid rgba(221, 221, 221, 0.5);
  width: 100%;
  height: fit-content;
  box-shadow: 0px 1.2rem 1.6rem rgba(16, 24, 40, 0.1), 0px 0.4rem 0.6rem rgba(16, 24, 40, 0.05);
  padding: 3rem 7rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}

.big-text {
  font-weight: 700;
  font-size: 24px;
  line-height: 38.9px;
  color: #000000;
  margin-bottom: 2rem;

  &.success{
    text-align: center;
    color: green;
  } 
}

.small-text {
  margin-bottom: 1rem;

  &.success{
    text-align: center;
  } 
}

.form-container > p {
  font-size: 1.125rem/1.5rem;
  margin-bottom: 2.5rem;
  line-height: 24px;
}

.input-box {
  margin-bottom: 1.8rem;
  width: 100%;
}

.input-box:last-child {
  margin-bottom: 0rem;
  background-color: #727272;
}

.input-box input {
  width: 100%;
  border: 1px solid rgba(221, 221, 221, 0.5);
  padding: 14px 22px;
  height: 52px;
  border-radius: 10px;
  font-size: 16px;
  line-height: 1.5rem;
  color: #000000;
}

.input-box input:focus {
  border: 1px solid #0892D0;
}

.input-box input.error {
  border: 1px solid #F83C1E;
}

.input-box input::placeholder {
  color: #727272;
}

small.error {
  color: #F83C1E;
}

.input-box label {
  font-size: 16px;
  font-weight: 100;
  position: absolute;
  top: 1.5rem;
  left: 22px;
  color: #727272;
}

.form-button {
  display: flex;
  padding: 0.875rem 3rem;
  margin: 2.5rem auto;
  border-radius: 5px;
  background-color: #0892d0;
  border: none;
  color: #ffffff;
  font-size: 16px;
  line-height: 24px;
}

.form-button:hover {
  transform: scale(0.95);
}

.form-loader {
  align-self: flex-end;
}

.submit-gif {
  color: #FFFFFF;
  text-align: center;
  border: 0;
  background-color: transparent;
}

.image {
  margin: 36px auto;
  width: 120px;
}

.logo {
  width: 125px;
}

b {
  font-weight: bold;
  font-family: inherit;
}

.close {
  margin: 0px 0px 0px auto;
}

.text {
  width: 90%;
  font-family: inherit;
  font-size: 16px;
  text-align: center;
  color: #727272;
  line-height: 24px;
}

.title {  
  font-family: inherit;
  font-weight: 700;
  font-size: 24px;
  line-height: 39px;
}

.max {
  background: rgba(233, 233, 233, 0.83);
}

@media (max-width: 1100px) {
  .register-container {
    width: 100%;
    height: 100vh;
    background-color: white;
  }
  .slider {
    display: none;
  }

  .form-side { 
    padding: 8px !important;
    overflow: hidden !important;
    background: white;
    margin: auto;
  }

  .form-container {
    padding: 2rem !important;
    width: 100%;
    background: white;    
  }

  .slider-base {
    width: 80% !important;
  }

  .alt-text,
  .form-container,
  .slider-text > h3,
  .slider-text > p,
  .big-text,
  .small-text,
  .input-box input::placeholder {
    font-size: 10px !important;
    margin-bottom: 8px !important;
  }

  .input-box input {
    height: 40px !important;
  }

  .alt-text {
    margin-top: 5px !important;
    
  }

  .big-text {
    margin: auto;
  }

  .form-button {
    font-size: 10px;
    line-height: 18px;
    margin-top: 10px;
  }
  
}
</style>



// WEBPACK FOOTER //
// src/components/pages/ForgotPassword.vue